/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Checkbox, Card, Col, Row, Slider, DatePicker } from 'antd';
import dayjs from 'dayjs';
import { BodyTextKey, BodyTextValue } from '../CommonText';

import english from '../../Translations/English.json';
import hindi from '../../Translations/Hindi.json';
import malayalam from '../../Translations/Malayalam.json';

const DoctorFilter = (props) => {
    // const dispatch = useDispatch();

    const [startingFee, setStartingFee] = useState(0);
    const [endFee, setEndFee] = useState(5000);
    const [startDate, setStartDate] = useState(moment().format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().add(7, 'days').format('YYYY-MM-DD'));
    const [radio, setRadio] = useState(['Male', 'Female']);    

    const dateFormat = 'YYYY-MM-DD';


    const langid = localStorage.getItem('INTL') ? (localStorage.getItem('INTL')) : 'en';
    const langdata = langid && langid == 'en' ? english : langid == 'ma' ? malayalam : langid == 'hin' ? hindi : english;

    // useEffect(() => {
    //     dispatch({ type: 'REQUEST_FILTER' });
    //     localStorage.setItem('PAGE', 1);
    // }, [dispatch]);

    const onStartDateChange = (date, dateString) => {
        
        setStartDate(moment(dateString));
        props.setStartDate(dateString);

        setEndDate(date === null ? null : moment(dateString).add(7, 'days'));
        props.setEndDate(date === null ? null : moment(dateString).add(7, 'days').format('YYYY-MM-DD'));

        props.setCurrentPage(1);

        if (date !== null) {
            // dispatch({ type: START_DATE_CHANGE, start: moment(date), end: moment(dateString).add(7, 'days') });
        }
    };

    const onEndDateChange = (date, dateString) => {
        
        setEndDate(dateString);
        props.setEndDate(dateString);
        props.setCurrentPage(1);


        if (date !== null) {
            // dispatch({ type: END_DATE_CHANGE, end: date });
        }
    };

    const onConsultChange = (value) => {
        props.setConsultationType(value);
        props.setCurrentPage(1);
        
        // if ([2, 4].includes(value[0]) || [2, 4].includes(value[1]) || [2, 4].includes(value[2])) {
        //     localStorage.setItem('CONSULTATIONTYPE_FLAG', 'checked');
        // } else {
        //     localStorage.setItem('CONSULTATIONTYPE_FLAG', 'unchecked');
        // }
        // dispatch({ type: CONSULT_CHECKED, payload: value });
    };


    const onRadioChange = value => {
        setRadio(value);
        
        if (value.length === 1) {
            props.setRadio(value);
        } else if (value.length === 2) {
            props.setRadio('');
        } else if (value.length === 0) {
            props.setRadio('');
        }
        props.setCurrentPage(1);

    };

    const onSliderChange = () => {
        // dispatch({ type: FEE_RANGE, low: value[0], high: value[1] });
    };

    const onSliderAfterChange = value => {
        setStartingFee(value[0]);
        props.setStartingFee(value[0]);
        setEndFee(value[1]);
        props.setEndFee(value[1]);

        props.setCurrentPage(1);
    };

    const disabledDate = current => current <= moment().subtract(1, 'days').endOf('day');

    const disabledEndDate = endDate => {
        const startDateValue = startDate;
        if (!endDate || !startDateValue) {
            return false;
        }
        return endDate.valueOf() <= startDateValue.valueOf();
    };

    return (
        <div>
            <Card title={langdata.Filter ? langdata.Filter : 'Filter'} style={{ height: '300px',
                //  width : '250px'
            }}>
                <Checkbox.Group style={{ width: '100%' }}>
                    <Row>
                        <Col span={24}>
                            <BodyTextKey text = {langdata.ConsultationDate ? langdata.ConsultationDate : 'Consultation Date'} />
                        </Col>
                        <Col span={24} style={{
                            marginTop : '10px'
                        }}>
                            <BodyTextValue text = {langdata.From ? langdata.From : 'From' } />
                        </Col>
                        
                        <Col span={24} style={{
                            marginTop : '5px'
                        }}>
                            <DatePicker
                                value={dayjs(moment(startDate).format('YYYY-MM-DD'), dateFormat)}
                                format={dateFormat}
                                onChange={onStartDateChange}
                                disabledDate={disabledDate}
                                allowClear={false}
                                style={{ width : '100%'}}
                            />
                        </Col>
                        <Col span={24} style={{
                            marginTop : '10px'
                        }}>
                            <BodyTextValue text = {langdata.To ? langdata.To : 'To' } />
                        </Col>
                        <Col span={24} style={{
                            marginTop : '5px'
                        }}>
                            <DatePicker
                                value={dayjs(moment(endDate).format('YYYY-MM-DD'), dateFormat)}
                                format={dateFormat}
                                onChange={onEndDateChange}
                                disabledDate={disabledEndDate}
                                allowClear={false}
                                style={{ width : '100%'}}
                            />
                        </Col>
                        <br />
                    </Row>
                </Checkbox.Group>
            </Card>
            <Card style={{ marginTop: '2%' ,
                //  width : '250px' 
            }}>
                <Checkbox.Group
                    style={{ width: '100%', height: 'auto' }}
                    defaultValue={[1, 3, 2, 4]}
                    onChange={onConsultChange}
                >
                    <Row>
                        <Col span={24} >
                            <BodyTextKey text = {langdata.ConsultationType ? langdata.ConsultationType : 'Consultation Type' } />
                        </Col>
                        <Col span={24} key={1}
                            style={{
                                marginTop : '10px'
                            }}>
                            <Checkbox value={1}> <BodyTextValue text = {langdata.HospitalVisit ? langdata.HospitalVisit : 'Hospital Visit'} /></Checkbox>
                        </Col>
                        <Col span={24} key={3} style={{
                            marginTop : '10px'
                        }}>
                            <Checkbox value={3}><BodyTextValue text = {langdata.ConsultOnline ? langdata.ConsultOnline : 'Consult Online'} /></Checkbox>
                        </Col>
                        <Col span={24} key={2} style={{
                            marginTop : '10px'
                        }}>
                            <Checkbox value={2}><BodyTextValue text = {langdata.OndemandHospital ? langdata.OndemandHospital : 'Ondemand Hospital'} /></Checkbox>
                        </Col>
                        <Col span={24} key={4} style={{
                            marginTop : '10px'
                        }}>
                            <Checkbox value={4}><BodyTextValue text = {langdata.OndemandVideo ? langdata.OndemandVideo : 'Ondemand Video' } /></Checkbox>
                        </Col>
                    </Row>
                </Checkbox.Group>
            </Card>
            <Card style={{ height: 'auto', marginTop: '2%',
                //  width : '250px' 
            }}>
                <Col span={24}>
                    <BodyTextKey text = {langdata.Fee ? langdata.Fee : 'Fee' } />
                </Col>
                <div>
                    <Slider
                        min={0}
                        max={5000}
                        range
                        step={10}
                        defaultValue={[0, 5000]}
                        onChange={onSliderChange}
                        onAfterChange={onSliderAfterChange}
                    />
                    <p style={{ textAlign: 'center' }}>
                        <BodyTextValue text = {`Rs ${startingFee} - Rs ${endFee} `} />
                    </p>
                </div>
            </Card>
            <Card style={{ height: 'auto', marginTop: '2%',
                //  width : '250px',
                marginBottom : '5%' }}>
                <Checkbox.Group style={{ width: '100%' }} onChange={onRadioChange} defaultValue={radio}>
                    <Row>
                        <Col span={24} style={{
                            marginTop : '-20px'
                        }}>
                            <BodyTextKey text = {langdata.Gender ? langdata.Gender : 'Gender'} />
                        </Col>
                        <Col span={24} key={1} style={{
                            marginTop : '10px'
                        }}>
                            <Checkbox value={'Male'}><BodyTextValue text = {langdata.Male ? langdata.Male : 'Male'} /></Checkbox>
                        </Col>
                        <Col span={24} key={3} style={{
                            marginTop : '10px'
                        }}>
                            <Checkbox value={'Female'}><BodyTextValue text = {langdata.Female ? langdata.Female : 'Female'} /></Checkbox>
                        </Col>
                    </Row>
                </Checkbox.Group>
            </Card>
        </div>
    );
};

DoctorFilter.propTypes = {
    consultation: PropTypes.object,
};

export default DoctorFilter;
